import { z } from 'zod';
const readQueryParams = z.object({
    createdBefore: z.string().optional(),
});
export const commentThreadApiRoutes = {
    listByProject: {
        method: 'GET',
        path: '/organization/:organizationId/comment-threads/project/:projectId',
        output: {},
    },
    unreads: {
        method: 'GET',
        path: '/organization/:organizationId/comment-threads/unreads',
        output: {},
    },
    markThreadRead: {
        method: 'POST',
        path: '/organization/:organizationId/comment-threads/:commentThreadId/mark-read',
        output: {},
    },
    read: {
        method: 'GET',
        // used recipient side
        path: '/organization/:organizationId/comment-threads/project/:projectId/orgRecipient/:orgRecipientId',
        q: readQueryParams,
        output: {},
    },
    readById: {
        method: 'GET',
        // used sender side
        path: '/organization/:organizationId/comment-threads/:commentThreadId',
        q: readQueryParams,
        output: {},
    },
    postComment: {
        method: 'POST',
        path: '/organization/:organizationId/comment-threads/:commentThreadId/comments',
        input: z.object({
            message: z.string(),
            parentCommentId: z.string().max(2000).optional(),
        }),
        output: {},
    },
    removeComment: {
        method: 'DELETE',
        path: '/organization/:organizationId/comment-threads/:commentThreadId/comments/:commentId',
        output: {},
    },
    recentComments: {
        method: 'GET',
        path: '/organization/:organizationId/comment-threads/project/:projectId/recent-comments',
        output: {},
    },
};
//# sourceMappingURL=comment-thread-api-routes.js.map